define(function(require,exports,module){
	var Doc=window.Document || false,
		Parser=window.DOMParser || false;
	
		// Consts
	var XMLMIME='text/xml',
		PARSERERROR="parsererror";

	function isXML(doc){
		return !!(doc && ((Doc && doc instanceof Doc) || (doc.documentElement && doc.xml)));
	}
	function isValid(doc){
		return !!(doc && !doc.getElementsByTagName(PARSERERROR).length);
	}
	function parse(xml){
		if(isXML(xml)){
			return xml;
		}
		return xml && Parser && (new Parser().parseFromString(xml,XMLMIME));
	}

	return {
		parse : function(xml){
			var doc=parse(xml);
			return doc && isValid(doc) ? doc : null;
		},

		isXML 	: isXML,

		isValid : function(doc){
			return !!(isXML(doc) && isValid(doc));
		} 
	};
});